import { react2angular } from 'react2angular';
import {TimePicker} from './TimePicker';

// Webtip module is needed for React to render
angular.module('webtip.module')
  .component('timePicker', react2angular(TimePicker, ['mode', 'timeStamp', 'angularCallback', 'showResetButton', 'startDate', 'endDate'], []));
